// The API (qr-tracker-api). The panel lives at qrpanel.adsctv.net; the API and
// the short links share qr.adsctv.net. Locally the API runs on 5200.
// REACT_APP_API_URL at build time overrides both.
const PRODUCTION_API_URL = "https://qr.adsctv.net/api";

const local = ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const API_URL =
  process.env.REACT_APP_API_URL || (local ? "http://localhost:5200/api" : PRODUCTION_API_URL);
